import type { FormInstance, RuleObject } from 'rc-field-form/lib/interface';

import { ICampaignCustomText, ICustomfieldsReturnValue, LocationState } from '../typings';

import { config } from './config';

export const getDefaultLocationState = (defaultPath: string): LocationState => ({
  from: {
    pathname: defaultPath,
  },
});

export function getConfirmPasswordValidator(passwordField: string, rejectMessage: string) {
  return function confirmPasswordValidator({ getFieldValue }: FormInstance): RuleObject {
    return {
      validator(rule, value) {
        if (!value || value === getFieldValue(passwordField)) return Promise.resolve();

        return Promise.reject(rejectMessage);
      },
    };
  };
}

export const getRendererUrl = (params: {
  text?: string;
  campaignId?: string;
  templateId?: string;
  customText?: ICampaignCustomText[];
}): string => {
  const queryParams = [];

  if (params.text) {
    queryParams.push(`t=${encodeURIComponent(params.text)}`);
  }

  if (params.campaignId) {
    queryParams.push(`c=${encodeURIComponent(params.campaignId)}`);
  }

  if (params.templateId) {
    queryParams.push(
      `p=${encodeURIComponent(
        JSON.stringify({ templateId: params.templateId, customText: params.customText ? params.customText : [] })
      )}`
    );
  }

  return `${config.RENDERER_URL}${queryParams.length ? `?${queryParams.join('&')}` : ''}`;
};

export const copyTextToClipboard = async (text?: string): Promise<boolean> => {
  if (text) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  return false;
};

export const parseCustomText = (customText: ICustomfieldsReturnValue): ICampaignCustomText[] => {
  return Object.entries(customText)
    .filter(([layerName, text = '']) => !!text.trim())
    .map(([layerName, text]) => ({ layerName, text }));
};
